/* workflows: перевод строк интерфейса. Ключ — русская строка ровно как в коде. */
const d: Record<string, string> = {
  // ── окно «Рабочие процессы»: боковая панель, шапка, список ──
  "Рабочие процессы": "Workflows",
  "Отчеты": "Reports",
  "Настройки": "Settings",
  "Рассылки": "Broadcasts",
  "Входящие": "Inbox",
  "Контакты": "Contacts",
  "Дашборд": "Dashboard",
  "Каналы": "Channels",
  "AI-агенты": "AI agents",
  "шаблон": "template",
  "Раздел «{label}» в демо не открывается": "The “{label}” section does not open in the demo",
  "Разговор начался": "Conversation started",
  "Курок": "Trigger",
  "Вы": "You",
  "В": "Y",
  "Процесс «{name}» создан из шаблона «{template}» — проверьте шаги и включите его": "Workflow “{name}” created from the “{template}” template — review the steps and turn it on",
  "Процесс «{name}» создан: добавьте шаги к триггеру «{trigger}»": "Workflow “{name}” created: add steps to the “{trigger}” trigger",
  "Процесс «{name}» включён и начал выполняться": "Workflow “{name}” is on and running",
  "Процесс «{name}» приостановлен и больше не запускается": "Workflow “{name}” is paused and no longer runs",
  "Процесс «{name}» удалён вместе со всеми шагами": "Workflow “{name}” deleted along with all its steps",
  "Демо-данные включены: в рабочем пространстве четыре процесса в разных статусах": "Demo data enabled: the workspace has four workflows in different statuses",
  "Демо-данные выключены — процессов снова нет": "Demo data disabled — no workflows again",
  "рабочее пространство → рабочие процессы": "workspace → workflows",
  "Активных: {n}": "Active: {n}",
  "Демо-данные": "Demo data",
  "Пробный период Growth Plan закончится 3 ноября 2026 — через 6 дней. Обновите тариф, чтобы не потерять доступ.":
    "Your Growth Plan trial ends on 3 November 2026 — in 6 days. Upgrade your plan to keep access.",
  "Начало работы": "Getting started",
  "Чеклист онбординга": "Onboarding checklist",
  "Демо-режим: смена тарифа здесь недоступна": "Demo mode: changing the plan is not available here",
  "Обновить тариф": "Upgrade plan",
  "Поиск": "Search",
  "Поиск рабочих процессов": "Search workflows",
  "Очистить поиск": "Clear search",
  "Добавить рабочий процесс": "Add workflow",
  "Добавить": "Add",
  "Варианты создания": "Creation options",
  "Начать с нуля": "Start from scratch",
  "Из шаблона": "From a template",
  "Ещё действия": "More actions",
  "Шаблоны рабочих процессов": "Workflow templates",
  "Импорт процессов": "Import workflows",
  "Экспорт списка": "Export list",
  "«{label}» в демо-режиме недоступен": "“{label}” is not available in demo mode",
  "шаблон «{name}»": "template “{name}”",
  "с нуля": "from scratch",
  "обновлён {date}": "updated {date}",
  "По запросу «{query}» ничего не нашлось": "Nothing found for “{query}”",
  "Попробуйте другое название или очистите поиск — процессы ищутся и по названию шаблона.": "Try another name or clear the search — workflows are also matched by template name.",
  "Включить демо-данные": "Enable demo data",
  "Всего процессов: {n} · шаблонов в галерее: {templates}. Демо-режим: данные живут только на этой странице.":
    "Total workflows: {n} · templates in the gallery: {templates}. Demo mode: data lives only on this page.",
  "Демо-режим: процессы живут только на этой странице и не сохраняются после перезагрузки.": "Demo mode: workflows live only on this page and are not saved after a reload.",
  "Демо-режим: справка о шаблоне «{name}» в макете недоступна": "Demo mode: help for the “{name}” template is not available in the mockup",
  "Демо-режим: добавление шагов в редакторе недоступно": "Demo mode: adding steps in the editor is not available",
  "шагов": "step|steps",

  // ── схема ──
  "Приблизить схему": "Zoom in on the diagram",
  "Приблизить": "Zoom in",
  "Отдалить схему": "Zoom out of the diagram",
  "Отдалить": "Zoom out",
  "Вписать схему в окно": "Fit the diagram to the window",
  "Вписать в окно": "Fit to window",
  "Добавьте триггер, чтобы процесс запускался": "Add a trigger so the workflow can run",
  "Шаги: {n} / {limit}": "Steps: {n} / {limit}",
  "Схема масштабируется кнопками слева": "Use the buttons on the left to zoom the diagram",

  // ── редактор процесса ──
  "Не задан": "Not set",
  "Назад к рабочим процессам": "Back to workflows",
  "Назад": "Back",
  "создан с нуля": "created from scratch",
  "Удалить процесс": "Delete workflow",
  "Приостановить": "Pause",
  "Включить": "Turn on",
  "Триггер": "Trigger",
  "Шаблон": "Template",
  "Создан с нуля": "Created from scratch",
  "Автор": "Author",
  "Обновлён": "Updated",
  "Шаги процесса": "Workflow steps",
  "Добавить шаг": "Add step",

  // ── окно «Новый рабочий процесс» ──
  "Закрыть окно": "Close window",
  "Использовать шаблон": "Use template",
  "Новый рабочий процесс": "New workflow",
  "Шаблон «{name}» — {n} шага действий. Все шаги можно поменять после создания.": "Template “{name}” — {n} action steps. All steps can be changed after creation.",
  "Название процесса": "Workflow name",
  "Например, Приветствие новых лидов": "e.g. New lead welcome",
  "Введите название — от 2 символов": "Enter a name — at least 2 characters",
  "Триггер запуска": "Start trigger",
  "Триггер — событие, после которого процесс начинает выполняться. Поменять его можно в редакторе.": "A trigger is the event that starts the workflow. You can change it in the editor.",
  "Новый процесс": "New workflow",
  "Создать без шаблона": "Create without a template",
  "Отмена": "Cancel",
  "Создать": "Create",

  // ── галерея шаблонов ──
  "Новый": "New",
  "Шаблоны поиска": "Search templates",
  "Поиск по шаблонам": "Search templates",
  "Просмотрите шаблоны рабочих процессов": "Browse workflow templates",
  "Выберите шаблон, чтобы начать создание рабочего процесса.": "Pick a template to start building a workflow.",
  "Шаблоны не нашлись": "No templates found",
  "Попробуйте другую категорию или очистите поиск — шаблоны ищутся по названию и описанию.": "Try another category or clear the search — templates are matched by name and description.",
  "Сбросить фильтры": "Reset filters",
  "Используйте шаблон": "Use template",
  "Назад к шаблонам": "Back to templates",
  "Преимущества": "Benefits",
  "Как это работает": "How it works",
  "Узнайте больше об этом шаблоне": "Learn more about this template",

  // ── моки: категории, статусы, триггеры, подсказки ──
  "Все шаблоны": "All templates",
  "Автоответчик": "Auto-reply",
  "Маршрутизация И Назначение": "Routing & Assignment",
  "Бизнес-Процессы": "Business Processes",
  "Надзор И Отчетность": "Supervision & Reporting",
  "Мета-Реклама «Нажмите в WhatsApp»": "Meta Click-to-WhatsApp Ads",
  "Реклама В Мессенджерах": "Messenger Ads",
  "Активен": "Active",
  "Черновик": "Draft",
  "Приостановлен": "Paused",
  "Новый контакт в рабочем пространстве": "New contact in the workspace",
  "Звонок завершён": "Call ended",
  "Получено входящее сообщение": "Incoming message received",
  "У вас пока нет рабочего процесса.": "You have no workflows yet.",
  "Используйте рабочие процессы для автоматизации процессов в маркетинге, продажах, поддержке, уведомлениях и многом другом.":
    "Use workflows to automate marketing, sales, support, notifications and much more.",
  "Начните с шаблона": "Start with a template",
  "Что такое рабочий процесс": "What is a workflow",
  "Это цепочка действий: триггер запускает её, а дальше автоматически уходят сообщения, назначаются агенты и создаются задания.":
    "It is a chain of actions: a trigger starts it, then messages are sent, agents are assigned and tasks are created automatically.",
  "С чего начать": "Where to start",
  "Возьмите готовый шаблон из галереи — он уже собран из рабочих шагов. Или начните с нуля и добавьте триггер вручную.":
    "Take a ready-made template from the gallery — it is already built from working steps. Or start from scratch and add a trigger manually.",
  "Что такое шаг": "What is a step",
  "Один шаг — одно действие процесса. В процессе может быть до 100 шагов, а схема наглядно показывает порядок и ветки.":
    "One step is one action of the workflow. A workflow can have up to 100 steps, and the diagram shows the order and branches.",
  "Шаблоны уже собраны из проверенных шагов: выберите подходящий, переименуйте под свою задачу — и процесс можно включать.":
    "Templates are built from proven steps: pick one, rename it for your task — and the workflow is ready to turn on.",

  // ── моки: шаблон «Сводка звонков» ──
  "Сводка звонков по журналу": "Call summary from the call log",
  "После каждого завершения звонка автоматически записывайте структурированное резюме разговора в карточку контакта.":
    "After every call, automatically save a structured summary of the conversation to the contact card.",
  "Каждый звонок заканчивается одинаково: менеджер дописывает итог в CRM, а половина деталей теряется. Этот процесс сам записывает резюме разговора — тему, договорённости и следующие шаги — и складывает его в карточку контакта.":
    "Every call ends the same way: the manager types the outcome into the CRM and half the details get lost. This workflow writes the call summary itself — topic, agreements and next steps — and stores it in the contact card.",
  "Менеджеры не тратят время на заметки после звонка.": "Managers don't spend time on notes after the call.",
  "Руководитель видит, о чём именно договорились с клиентом.": "The team lead sees exactly what was agreed with the customer.",
  "История разговоров остаётся в карточке даже после смены менеджера.": "The conversation history stays in the card even when the manager changes.",
  "Контакт или менеджер завершает звонок.": "The contact or the manager ends the call.",
  "Процесс получает журнал звонка и расшифровку разговора.": "The workflow receives the call log and the transcript.",
  "Резюме сохраняется в поле контакта «Последний звонок».": "The summary is saved to the contact field “Last call”.",
  "Менеджеру уходит сообщение с кратким итогом.": "The manager gets a message with a brief outcome.",
  "Расшифровать звонок": "Transcribe the call",
  "Действие:": "Action:",
  "Получить журнал разговора и ключевые темы.": "Get the call log and key topics.",
  "Записать резюме": "Save summary",
  "Поле:": "Field:",
  "Последний звонок": "Last call",
  "Успех": "Success",
  "Сообщение менеджеру": "Message to manager",
  "Сообщение:": "Message:",
  "Итог звонка с $contact.name: $call.summary.": "Call outcome with $contact.name: $call.summary.",

  // ── моки: шаблон «Пропущенный звонок» ──
  "Задание: Отслеживание пропущенного звонка": "Task: Missed call follow-up",
  "Автоматически создавайте задание на перезвон, когда клиент звонит и не дожидается ответа.": "Automatically create a callback task when a customer calls and hangs up before an answer.",
  "Пропущенный звонок — это почти потерянная сделка. Процесс проверяет, ответил ли кто-то клиенту, и если нет — ставит задание ответственному с именем контакта и временем звонка.":
    "A missed call is almost a lost deal. The workflow checks whether anyone answered the customer and, if not, creates a task for the assignee with the contact's name and the call time.",
  "Ни один пропущенный звонок не остаётся без перезвона.": "No missed call goes without a callback.",
  "Задание сразу попадает к ответственному агенту, а не в общую очередь.": "The task goes straight to the assigned agent, not to the shared queue.",
  "Руководитель видит, сколько звонков команда пропустила за неделю.": "The team lead sees how many calls the team missed this week.",
  "Клиент звонит и завершает вызов, не дождавшись ответа.": "The customer calls and hangs up before getting an answer.",
  "Процесс проверяет длительность ожидания.": "The workflow checks the waiting time.",
  "Контакт назначается ответственному агенту.": "The contact is assigned to the responsible agent.",
  "Агент получает задание перезвонить в течение 15 минут.": "The agent gets a task to call back within 15 minutes.",
  "Пропущенный звонок": "Missed call",
  "Проверить ожидание": "Check waiting time",
  "Условие:": "Condition:",
  "Ответа не было дольше 30 секунд": "No answer for more than 30 seconds",
  "Назначить ответственного": "Assign an owner",
  "Выберите команду": "Select a team",
  "Задание на перезвон": "Callback task",
  "Перезвоните $contact.name — пропущенный звонок в $call.time.": "Call $contact.name back — missed call at $call.time.",

  // ── моки: шаблон «Наименее открытые контакты» ──
  "Задание: Наименее открытые контакты": "Assignment: Fewest open contacts",
  "Назначайте контакт агенту с наименьшим количеством открытых диалогов — так ответ приходит быстрее.": "Assign the contact to the agent with the fewest open conversations — so the reply comes faster.",
  "Когда ваши контакты впервые обращаются в вашу компанию, вы можете автоматически назначать их агентам с наименьшим количеством открытых контактов. Агенты, не перегруженные открытыми контактами, с большей вероятностью смогут быстрее ответить вашим клиентам.":
    "When contacts reach out to your company for the first time, you can automatically assign them to the agents with the fewest open contacts. Agents who are not overloaded with open contacts are more likely to reply to your customers faster.",
  "Убедитесь, что все контакты оперативно переданы агентам.": "Make sure every contact is promptly handed to an agent.",
  "Экономьте время и повышайте точность данных по сравнению с процессами ручного назначения.": "Save time and improve data accuracy compared with manual assignment.",
  "Улучшение времени отклика и повышение удовлетворённости клиентов.": "Better response times and higher customer satisfaction.",
  "Контакт инициирует разговор, отправив сообщение.": "The contact starts a conversation by sending a message.",
  "Отправьте ответное сообщение контакту.": "Send a reply to the contact.",
  "Назначьте контакт агенту, у которого наименьшее количество открытых контактов.": "Assign the contact to the agent with the fewest open contacts.",
  "Отправьте сообщение, чтобы уведомить контактное лицо о назначении агента.": "Send a message to let the contact know an agent has been assigned.",
  "Приветственное сообщение": "Welcome message",
  "Здравствуйте, $contact.name, я ищу сотрудника в команду, которому можно передать диалог.": "Hello $contact.name, I'm finding a team member to hand this conversation to.",
  "Назначить в команду…": "Assign to team…",
  "Сообщение о задании": "Assignment message",
  "Вам назначен исполнитель $assignee.firstname.": "You have been assigned to $assignee.firstname.",

  // ── моки: шаблон «Круговой турнир» ──
  "Задание: Круговой турнир": "Assignment: Round robin",
  "Назначайте контакт члену команды поочерёдно каждый раз, когда контакт начинает разговор.": "Assign the contact to team members in turn every time a contact starts a conversation.",
  "Круговое распределение убирает ручную работу: каждый новый диалог по очереди уходит следующему агенту команды, и никто не остаётся без нагрузки или, наоборот, с перегрузом.":
    "Round-robin distribution removes manual work: each new conversation goes to the next agent on the team in turn, so nobody is left idle or overloaded.",
  "Нагрузка распределяется равномерно, без споров «кто взял клиента».": "The load is spread evenly, with no arguments about who took the customer.",
  "Ни один агент не пропускает свою очередь.": "No agent skips their turn.",
  "Процесс легко приостановить в отпуск или на время обучения.": "The workflow is easy to pause for holidays or training.",
  "Контакт начинает разговор.": "The contact starts a conversation.",
  "Процесс берёт следующего агента из очереди команды.": "The workflow takes the next agent from the team queue.",
  "Контакт назначается этому агенту.": "The contact is assigned to that agent.",
  "Агент получает сообщение с именем контакта.": "The agent gets a message with the contact's name.",
  "Приветствие": "Greeting",
  "Спасибо за сообщение! Сейчас подключится наш специалист.": "Thanks for your message! A specialist will join shortly.",
  "Назначить по очереди": "Assign in turn",
  "Уведомить исполнителя": "Notify assignee",
  "Новый диалог: $contact.name.": "New conversation: $contact.name.",

  // ── моки: шаблон «Круговой турнир + онлайн» ──
  "Задание: Круговой турнир + Только онлайн-формат": "Assignment: Round robin + Online only",
  "Круговое назначение только для агентов онлайн: офлайн-коллеги пропускаются до конца смены.": "Round-robin assignment for online agents only: offline colleagues are skipped until the end of their shift.",
  "Если половина команды офлайн, круговое распределение теряет смысл. Процесс проверяет статус агентов и передаёт контакт только тому, кто сейчас на линии.":
    "If half the team is offline, round robin loses its point. The workflow checks agent status and hands the contact only to someone who is online right now.",
  "Клиент получает ответ от того, кто действительно на месте.": "The customer gets a reply from someone who is actually there.",
  "Офлайн-агенты не получают просроченные задания.": "Offline agents don't receive overdue tasks.",
  "Процесс сам переключается, когда коллега выходит на линию.": "The workflow switches over by itself when a colleague comes online.",
  "Процесс проверяет, кто из команды сейчас онлайн.": "The workflow checks who on the team is online now.",
  "Контакт назначается следующему онлайн-агенту.": "The contact is assigned to the next online agent.",
  "Агент получает задание взять диалог.": "The agent gets a task to take the conversation.",
  "Только онлайн": "Online only",
  "Статус агента — «на линии»": "Agent status is “online”",
  "Назначить по кругу": "Assign round robin",
  "Задание агенту": "Task for agent",
  "Возьмите диалог: $contact.name.": "Take the conversation: $contact.name.",

  // ── моки: шаблон «Отменить назначение» ──
  "Задание: Отменить назначение после завершения обсуждения": "Assignment: Unassign after the conversation closes",
  "Снимайте назначение, если обсуждение завершилось раньше, чем агент успел ответить.": "Remove the assignment if the conversation closed before the agent managed to reply.",
  "Иногда клиент закрывает вопрос сам или пишет в другой канал. Процесс проверяет, активно ли ещё назначение, и возвращает контакт в очередь команды, чтобы агент не тратил время на закрытый диалог.":
    "Sometimes the customer resolves the issue themselves or writes in another channel. The workflow checks whether the assignment is still active and returns the contact to the team queue so the agent doesn't waste time on a closed conversation.",
  "Агенты не работают с уже закрытыми диалогами.": "Agents don't work on conversations that are already closed.",
  "Контакты возвращаются в очередь без ручных действий.": "Contacts return to the queue without manual actions.",
  "В отчётах не остаётся «зависших» назначений.": "No stale assignments are left in reports.",
  "Обсуждение завершается.": "The conversation closes.",
  "Процесс проверяет, активно ли назначение.": "The workflow checks whether the assignment is active.",
  "Если агент ещё не ответил — назначение снимается.": "If the agent hasn't replied yet, the assignment is removed.",
  "Контакт возвращается в очередь команды.": "The contact returns to the team queue.",
  "Обсуждение завершено": "Conversation closed",
  "Назначение ещё активно?": "Assignment still active?",
  "Агент не ответил": "Agent hasn't replied",
  "Снять назначение": "Unassign",
  "Контакт возвращён в очередь команды.": "Contact returned to the team queue.",

  // ── моки: шаблоны «Сообщение об отсутствии» ──
  "Сообщение об отсутствии": "Away message",
  "Отправляйте сообщение об отсутствии каждый раз, когда контакт начинает разговор вне смены.": "Send an away message every time a contact starts a conversation outside the shift.",
  "Клиент пишет вечером и не получает ответа — впечатление испорчено. Процесс отвечает сразу, честно говорит, когда вернётся команда, и сохраняет диалог открытым до утра.":
    "A customer writes in the evening and gets no reply — the impression is ruined. The workflow replies at once, says honestly when the team will be back, and keeps the conversation open until morning.",
  "Клиент получает ответ в ту же минуту, даже ночью.": "The customer gets a reply within the minute, even at night.",
  "Команда не просыпается от сообщений в нерабочее время.": "The team isn't woken up by messages outside working hours.",
  "Диалог остаётся в очереди и не теряется.": "The conversation stays in the queue and isn't lost.",
  "Процесс проверяет, есть ли кто-то из команды на линии.": "The workflow checks whether anyone on the team is online.",
  "Если все офлайн — уходит сообщение об отсутствии.": "If everyone is offline, an away message is sent.",
  "Диалог остаётся открытым до начала смены.": "The conversation stays open until the shift starts.",
  "Все офлайн?": "Everyone offline?",
  "Нет агентов на линии": "No agents online",
  "Спасибо за сообщение! Мы ответим, как только вернёмся на линию.": "Thanks for your message! We'll reply as soon as we're back online.",
  "Сообщение об отсутствии с указанием рабочего времени": "Away message with working hours",
  "Отправляйте сообщение об отсутствии с точными часами работы команды.": "Send an away message with the team's exact working hours.",
  "Клиенту важно понимать, когда ждать ответ. Процесс проверяет рабочее время и отправляет сообщение с часами работы — без общих формулировок «мы скоро ответим».":
    "Customers want to know when to expect a reply. The workflow checks working hours and sends a message with them — no vague “we'll get back to you soon”.",
  "Клиент сразу понимает, когда получит ответ.": "The customer immediately knows when to expect a reply.",
  "Меньше повторных сообщений «вы тут?».": "Fewer follow-up messages like “are you there?”.",
  "Часы работы меняются в одном месте, а не в каждом шаблоне.": "Working hours are changed in one place, not in every template.",
  "Процесс проверяет рабочее время команды.": "The workflow checks the team's working hours.",
  "Вне рабочих часов уходит сообщение с часами работы.": "Outside working hours a message with the hours is sent.",
  "В рабочие часы диалог сразу идёт к агенту.": "During working hours the conversation goes straight to an agent.",
  "Проверить рабочее время": "Check working hours",
  "Вне 09:00–19:00": "Outside 09:00–19:00",
  "Сообщение с часами работы": "Working hours message",
  "Мы работаем по будням с 09:00 до 19:00 и ответим в ближайшее рабочее время.": "We work weekdays from 09:00 to 19:00 and will reply during the next working hours.",

  // ── моки: шаблоны рекламы ──
  "Принимайте клики по рекламе в WhatsApp, приветствуйте контакт и сразу передавайте его продавцу.": "Capture WhatsApp ad clicks, greet the contact and hand them straight to a salesperson.",
  "Клиент нажимает кнопку в объявлении и попадает в WhatsApp. Процесс мгновенно отвечает, фиксирует источник «Мета-реклама» и передаёт диалог продавцу, пока интерес не остыл.":
    "The customer taps the button in the ad and lands in WhatsApp. The workflow replies instantly, records the source as “Meta ads” and hands the conversation to a salesperson while the interest is still warm.",
  "Клиент получает ответ в первые секунды после клика.": "The customer gets a reply within seconds of the click.",
  "В карточке контакта видно, из какого объявления пришёл лид.": "The contact card shows which ad the lead came from.",
  "Продавец получает тёплый контакт без ручной пересылки.": "The salesperson gets a warm contact without manual forwarding.",
  "Клиент нажимает кнопку в рекламном объявлении.": "The customer taps the button in the ad.",
  "Открывается диалог WhatsApp с приветствием.": "A WhatsApp conversation opens with a greeting.",
  "Источник сохраняется в поле контакта.": "The source is saved to a contact field.",
  "Диалог назначается продавцу команды.": "The conversation is assigned to a salesperson on the team.",
  "Клик по рекламе": "Ad click",
  "Приветствие из рекламы": "Ad greeting",
  "Здравствуйте! Вы писали по объявлению — расскажите, что ищете.": "Hello! You've reached us from an ad — tell us what you're looking for.",
  "Назначить продавцу": "Assign to salesperson",
  "Реклама В Мессенджерах: квалификация лида": "Messenger Ads: lead qualification",
  "Отвечайте на рекламу в мессенджерах и квалифицируйте контакт до передачи продавцу.": "Reply to messenger ads and qualify the contact before handing them to a salesperson.",
  "Реклама приводит много любопытных, но мало готовых к покупке. Процесс задаёт два квалифицирующих вопроса и передаёт продавцу только тех, кто назвал задачу и бюджет.":
    "Ads bring many curious people but few ready to buy. The workflow asks two qualifying questions and hands over only those who named a task and a budget.",
  "Продавцы тратят время только на целевые диалоги.": "Salespeople spend time only on qualified conversations.",
  "Клиент получает ответ сразу после клика по объявлению.": "The customer gets a reply right after clicking the ad.",
  "Ответы квалификации сохраняются в полях контакта.": "Qualification answers are saved to contact fields.",
  "Клиент отвечает на рекламу в мессенджере.": "The customer replies to an ad in a messenger.",
  "Процесс задаёт вопросы о задаче и сроках.": "The workflow asks about the task and timing.",
  "Ответы сохраняются в карточке контакта.": "The answers are saved to the contact card.",
  "Целевой контакт назначается менеджеру.": "A qualified contact is assigned to a manager.",
  "Сообщение из рекламы": "Message from an ad",
  "Квалификация": "Qualification",
  "Подскажите задачу и желаемый срок — подберём решение.": "Tell us your task and desired timing — we'll find a solution.",
  "Готов к покупке?": "Ready to buy?",
  "Бюджет и срок указаны": "Budget and timing provided",
  "Назначить менеджеру": "Assign to manager",

  // ── моки: готовые процессы демо-режима ──
  "Приветствие новых лидов": "New lead welcome",
  "Мария Петрова": "Maria Petrova",
  "Здравствуйте, $contact.name! Сейчас подключится специалист.": "Hello $contact.name! A specialist will join shortly.",
  "Сводка звонков отдела продаж": "Sales team call summary",
  "Алексей Ким": "Alexey Kim",
  "Ночной автоответчик": "Night auto-reply",
  "Ольга Смирнова": "Olga Smirnova",
  "Мы работаем по будням с 09:00 до 19:00.": "We work weekdays from 09:00 to 19:00.",
  "Пропущенный звонок — перезвон": "Missed call — callback",
  "Дмитрий Волков": "Dmitry Volkov",
  "Перезвоните $contact.name — пропущенный звонок.": "Call $contact.name back — missed call.",

  // ── источники знаний AI Assist ──
  "Выберите документ: PDF, DOCX или TXT до 20 МБ": "Choose a document: PDF, DOCX or TXT up to 20 MB",
  "Укажите полную ссылку, начиная с https://": "Enter the full link, starting with https://",
  "Добавьте название — по нему источник ищут в списке": "Add a name — it is used to find the source in the list",
  "Укажите адрес API, начиная с https:// — например https://api.hub.ru/v1/knowledge": "Enter the API address, starting with https:// — e.g. https://api.hub.ru/v1/knowledge",
  "Вставьте токен доступа: без него API не отдаст данные": "Paste the access token: the API won't return data without it",
  "Добавьте название источника": "Add a source name",
  "Вставьте текст-инструкцию: минимум 20 символов, иначе ассистенту нечего читать": "Paste the instruction text: at least 20 characters, otherwise the assistant has nothing to read",
  "Некорректный адрес — нужен полный URL, начиная с https://": "Invalid address — a full URL starting with https:// is required",
  "Добавьте токен доступа — без него сервис вернёт 401 Unauthorized": "Add an access token — without it the service returns 401 Unauthorized",
  "Отправляем тестовый запрос к эндпоинту…": "Sending a test request to the endpoint…",
  "Соединение установлено — сервис ответил и отдал данные для индексации": "Connection established — the service responded and returned data for indexing",
  "Регламент возвратов и обмена": "Returns and exchange policy",
  "Условия доставки по регионам": "Delivery terms by region",
  "Загружен документ · PDF": "Uploaded document · PDF",
  "{host} · {auth} · автообновление": "{host} · {auth} · auto-refresh",
  "Bearer-токен": "Bearer token",
  "{n} знаков текста": "{n} characters of text",
  "Синхронизировано": "Synced",
  "Готово": "Done",
  "API «{name}» подключён — ассистент прочитает данные и будет обновлять их автоматически": "API “{name}” connected — the assistant will read the data and keep it up to date automatically",
  "Источник «{name}» добавлен — AI Assist проиндексирует его и начнёт отвечать по нему": "Source “{name}” added — AI Assist will index it and start answering from it",
  "Источник «{name}» удалён — ассистент больше не будет на него опираться": "Source “{name}” deleted — the assistant will no longer rely on it",
  "Запрошено обновление «{name}» — новые данные появятся в течение 5 минут": "Refresh of “{name}” requested — new data will appear within 5 minutes",
  "Документ": "Document",
  "Ссылка": "Link",
  "Текст": "Text",
  "настройки → входящие → AI Assist → источники знаний": "settings → inbox → AI Assist → knowledge sources",
  "Источников: {n}": "Sources: {n}",
  "Доступы": "Access",
  "Источники знаний загружает администратор. Ассистент использует их, но не меняет документы.": "Knowledge sources are uploaded by an admin. The assistant uses them but never changes the documents.",
  "Назад к AI Assist": "Back to AI Assist",
  "Источники знаний AI": "AI knowledge sources",
  "Загружайте документы, ссылки и инструкции или подключайте источники по API — ассистент будет отвечать точнее.": "Upload documents, links and instructions or connect sources via API — the assistant will answer more accurately.",
  "Демо-режим: подробная справка по источникам знаний в макете недоступна": "Demo mode: detailed help on knowledge sources is not available in the mockup",
  "Узнать больше": "Learn more",
  "Источников знаний пока нет": "No knowledge sources yet",
  "Добавьте источники знаний, чтобы AI Assist отвечал по вашим документам и правилам, а не по общим догадкам.": "Add knowledge sources so AI Assist answers from your documents and rules, not from general guesses.",
  "Добавить источник знаний": "Add knowledge source",
  "Источник": "Source",
  "Тип": "Type",
  "Содержимое": "Content",
  "Добавлен": "Added",
  "Действия": "Actions",
  "Обновить данные из {name}": "Refresh data from {name}",
  "Обновить сейчас": "Refresh now",
  "Удалить источник {name}": "Delete source {name}",
  "Пока пусто — AI Assist отвечает только по шаблонам": "Empty so far — AI Assist answers from snippets only",
  "проиндексировано": "indexed",
  "API обновляется сам": "API refreshes itself",
  "Обновление индекса — до 5 минут": "Index refresh — up to 5 minutes",
  "Демо-режим: источники добавляются только в макете — проверка соединения имитируется, файлы не загружаются.": "Demo mode: sources are added only in the mockup — the connection check is simulated and files are not uploaded.",
  "Закрыть окно источника": "Close source window",
  "Новый источник знаний": "New knowledge source",
  "Ассистент читает источник и отвечает по нему. Документы, ссылки, тексты и API-подключения можно удалить в любой момент.": "The assistant reads the source and answers from it. Documents, links, texts and API connections can be deleted at any time.",
  "Выбрать файл или перетащить": "Choose a file or drag it here",
  "PDF, DOCX, TXT · до 20 МБ": "PDF, DOCX, TXT · up to 20 MB",
  "Текст-инструкция": "Instruction text",
  "Например: возврат оформляем в течение 14 дней. Клиент пишет номер договора и причину, мы высылаем форму заявления.": "e.g. Returns are processed within 14 days. The customer sends the contract number and reason, we send the claim form.",
  "Адрес API (эндпоинт)": "API address (endpoint)",
  "Метод GET, ответ в JSON или текст. Ассистент будет читать этот адрес по расписанию.": "GET method, JSON or text response. The assistant will read this address on a schedule.",
  "Заголовок авторизации": "Authorization header",
  "Токен доступа": "Access token",
  "Скрыть токен": "Hide token",
  "Показать токен": "Show token",
  "Проверяем…": "Checking…",
  "Проверить соединение": "Check connection",
  "{ms} мс": "{ms} ms",
  "Нет соединения": "No connection",
  "Проверим адрес и токен: сервис должен ответить кодом 200 и отдать записи для индексации.": "We'll check the address and token: the service must respond with 200 and return records for indexing.",
  "Пример ответа": "Sample response",
  "Проверка ничего не сохраняет — можно менять адрес и токен и проверять снова.": "The check saves nothing — you can change the address and token and check again.",
  "Автообновление": "Auto-refresh",
  "каждые 6 часов": "every 6 hours",
  "Токен хранится в защищённом виде": "The token is stored securely",
  "Название источника": "Source name",
  "Например, Регламент возвратов": "e.g. Returns policy",
  "Документ используется только внутри рабочего пространства. Клиенты не видят исходные файлы — только ответы ассистента.": "The document is used only inside the workspace. Customers never see the source files — only the assistant's answers.",
  "Подключить API": "Connect API",
  "Добавить источник": "Add source",
  "источников": "source|sources",
};
export default d;
